export const CUSTOM_PRESET_VALUE = 'custom'
